import { render, staticRenderFns } from "./BaseLoadingRoller.vue?vue&type=template&id=11169b06&scoped=true&"
import script from "./BaseLoadingRoller.vue?vue&type=script&lang=js&"
export * from "./BaseLoadingRoller.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoadingRoller.vue?vue&type=style&index=0&id=11169b06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11169b06",
  null
  
)

export default component.exports